import React from 'react';
import './TermsOverlay.css';

type TermsType = 'service' | 'location' | 'privacy';

interface TermsOverlayProps {
    type: TermsType;
    onClose: () => void;
}

const termsContent: Record<TermsType, { title: string; content: React.ReactNode }> = {
    service: {
        title: '서비스 이용약관',
        content: (
            <>
                <p>이 약관은 ㈜프리딕션(이하 "회사")이 제공하는 EView 관련 제반 서비스의 이용과 관련하여 "회사"와 이용자의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>

                <h3>제1조 (용어의 정의)</h3>
                <ol>
                    <li><strong>"EView"</strong>라 함은 "회사"가 운영하는 전기차 통합관리 솔루션 플랫폼(eview.im, EView 웹 애플리케이션)을 말합니다.</li>
                    <li><strong>"서비스"</strong>라 함은 설치되어 있는 단말기(PC, 태블릿, 휴대형 단말기 등의 각종 유무선 장치를 포함)와 상관없이 "회원"이 이용할 수 있는 EView 및 EView 관련 제반 서비스를 의미합니다.</li>
                    <li><strong>"이용자"</strong>라 함은 "EView"에 접속하여 이 약관에 따라 "회사"가 제공하는 "서비스"를 이용하는 회원 및 비회원을 말합니다.</li>
                    <li><strong>"회원"</strong>이라 함은 본 약관의 내용과 개인정보의 수집, 제공 및 활용에 대하여 동의를 한 다음 회원가입신청을 하고 "회사"에서 회원등록을 승낙한 이용자를 말합니다.</li>
                    <li><strong>"관리자 계정"</strong>이라 함은 기업 고객이 서비스 이용을 위해 생성하는 사내 메일 기반의 계정을 의미합니다.</li>
                    <li><strong>"아이디(ID)"</strong>는 "회원"의 식별과 "서비스" 이용을 위한 사내 이메일 주소를 의미합니다.</li>
                    <li><strong>"비밀번호"</strong>는 "회원"이 설정한 "아이디"와 일치하는 "회원"임을 확인하고, 비밀 보호를 위해 회원 자신이 정한 문자와 숫자의 조합을 의미합니다.</li>
                    <li><strong>"OBD 단말기"</strong>란 차량에 장착되어 배터리 데이터, 주행 정보, 위치 정보를 수집·전송하는 장치를 의미합니다.</li>
                    <li><strong>"이메일 도메인"</strong>이란 기업 회원가입 시 등록하는 회사 이메일 도메인으로, 해당 도메인의 이메일로 가입하는 직원은 자동으로 소속 회사에 등록됩니다.</li>
                    <li><strong>"유료서비스"</strong>라 함은 "회사"가 유료로 제공하는 각종 서비스(베이직, 스탠다드, 프리미엄, 엔터프라이즈) 및 이를 결제·이용하는 데 수반되는 제반 관련 서비스를 말합니다.</li>
                </ol>

                <h3>제2조 (약관의 게시와 개정)</h3>
                <ol>
                    <li>"회사"는 이 약관의 내용을 "회원"이 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.</li>
                    <li>"회사"는 「약관의 규제에 관한 법률」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」(이하 "정보통신망법") 등 관련법을 위반하지 않는 범위에서 이 약관을 개정할 수 있습니다.</li>
                    <li>"회사"가 약관을 개정하여 적용하고자 하는 경우에는 개정약관을 현행약관과 함께 서비스 초기화면에 공지하여야 합니다. 개정 약관은 공지한 날로부터 15일이 경과되면 적용됩니다.</li>
                    <li>전항의 규정에 따라 "회사"가 개정약관과 현행약관을 공지한 날로부터 15일 이내에 회원탈퇴를 하지 아니하는 경우에는 개정약관에 동의한 것으로 봅니다.</li>
                    <li>이 약관의 일부가 집행 불능으로 판단되더라도 나머지 부분은 계속해서 효력을 갖습니다.</li>
                </ol>

                <h3>제3조 (약관 이외의 준칙)</h3>
                <ol>
                    <li>"회사"는 개별 서비스에 대해서는 별도의 이용약관 및 운영정책(이하 "운영정책 등")을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 "운영정책 등"이 우선하여 적용됩니다.</li>
                    <li>이 약관에서 정하지 아니한 사항이나 해석에 대해서는 관계법령 또는 상관례에 따릅니다.</li>
                </ol>

                <h3>제4조 (이용계약 체결)</h3>
                <ol>
                    <li>이용계약은 "회원"이 되고자 하는 자(이하 "가입신청자")가 약관의 내용과 개인정보의 수집, 제공 및 활용에 대하여 동의를 한 다음 회원가입신청을 하고 "회사"가 이러한 신청에 대하여 승낙함으로써 체결됩니다.</li>
                    <li>"회사"는 "가입신청자"의 신청에 대하여 "서비스" 이용을 승낙함을 원칙으로 합니다. 다만, 다음 각 호에 해당하는 신청에 대하여는 회원가입을 인정하지 않거나 서비스 이용을 제한, 회원자격 상실 등의 조치를 할 수 있습니다.
                        <ul>
                            <li>가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우 (다만, 회원자격 상실 후 1년이 경과한 자로서 "회사"의 회원 재가입 승낙을 얻은 경우에는 예외)</li>
                            <li>실명이 아니거나 타인의 명의를 이용한 경우</li>
                            <li>허위의 정보를 기재하거나, "회사"가 요청하는 정보를 제공하지 않은 경우</li>
                            <li>허위 사업자 정보를 기재한 경우</li>
                            <li>가입신청자의 귀책사유로 인하여 승낙이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우</li>
                        </ul>
                    </li>
                    <li>"회사"는 "회원"의 종류에 따라 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.</li>
                    <li>"회사"는 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.</li>
                    <li>이용계약은 "회사"가 "가입신청자"의 신청을 승낙하였다는 의사표시를 신청절차 상에서 표시한 시점에 성립합니다.</li>
                    <li>"회사"는 "회원"에 대해 회사정책에 따라 요금제별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 서비스에 차등을 두거나 서비스를 일부 제한할 수 있습니다.</li>
                </ol>

                <h3>제5조 (회원의 탈퇴 및 자격상실)</h3>
                <ol>
                    <li>"회원"은 언제든지 "EView 고객센터", "이메일", "사내관리자"를 통해서 회원탈퇴를 요청할 수 있으며, "회사"는 관련법 등이 정하는 바에 따라 이를 수일 내에 탈퇴 처리하여야 합니다.</li>
                    <li>"회원"이 회원탈퇴를 한 경우 "회사"가 보유하고 있는 "회원"의 모든 정보는 탈퇴 처리 즉시 소멸되며, 차량 운행기록은 사용자의 신원을 확인할 수 없는 형태로 통계 데이터 활용을 위해 보관됩니다.</li>
                    <li>단, 다음 호의 어느 하나에 해당하는 경우, 탈퇴 처리가 거절될 수 있습니다.
                        <ul>
                            <li>"회원"이 "회사"에 대한 금전적인 채무가 존재하는 경우</li>
                            <li>"회원"의 요청으로 인한 회원탈퇴 시 3개월간 재가입신청이 제한됩니다. (단, "회사"와 "회원" 간에 사전 협의한 경우에는 재가입이 가능합니다.)</li>
                        </ul>
                    </li>
                </ol>

                <h3>제6조 (회원정보 변경 및 "아이디"·"비밀번호" 관리 의무)</h3>
                <ol>
                    <li>"회원"은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 아이디 등은 수정이 불가능합니다.</li>
                    <li>"회원"은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 "회사"에 변경사항을 알려야 합니다.</li>
                    <li>"회원"의 "아이디"와 "비밀번호"에 관한 관리책임은 "회원"에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.</li>
                    <li>"회원"은 "아이디" 및 "비밀번호"가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 "회사"에 통지하고 "회사"의 안내에 따라야 합니다.</li>
                </ol>

                <h3>제7조 (개인정보의 수집)</h3>
                <ol>
                    <li>"회사"는 서비스를 제공하기 위하여 관련법령의 규정에 따라 "회원"으로부터 필요한 개인정보를 수집합니다. 다음 사항을 필수사항으로 합니다.
                        <ul>
                            <li>관리자명, 관리자 연락처, 사내 이메일 주소, 사업자등록번호, 회사명, 이메일 도메인</li>
                        </ul>
                    </li>
                    <li>"회사"는 이용자의 개인식별이 가능한 개인정보를 수집한 때에는 반드시 당해 이용자의 동의를 받습니다.</li>
                </ol>

                <h3>제8조 (개인정보보호의 의무)</h3>
                <ol>
                    <li>"회사"는 "정보통신망법" 등 관계 법령이 정하는 바에 따라 "회원"의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 "회사"의 개인정보취급방침이 적용됩니다.</li>
                    <li>"회사"는 서비스 이용과 관련하여 "회원"으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다.</li>
                </ol>

                <h3>제9조 (서비스의 내용)</h3>
                <p>"회사"는 "회원"에게 아래와 같은 "서비스"를 제공합니다.</p>
                <ol>
                    <li>전기차 배터리 진단 및 SoH(State of Health) 예측</li>
                    <li>실시간 배터리 관제 및 모니터링</li>
                    <li>차량 운행 기록 및 주행 데이터 관리</li>
                    <li>운행 일지 자동 생성</li>
                    <li>차량 및 운전자 관리 기능</li>
                    <li>OBD 단말기를 통한 차량 데이터 수집 및 분석</li>
                    <li>기타 "회사"가 추가 개발하거나 다른 회사와의 제휴계약 등을 통해 "회원"에게 제공하는 일체의 서비스</li>
                </ol>

                <h3>제10조 (서비스의 제공)</h3>
                <ol>
                    <li>"서비스"는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.</li>
                    <li>"회사"는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 "서비스"의 제공을 일시적으로 중단할 수 있습니다.</li>
                    <li>"회사"는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검 시간은 서비스 제공화면에 공지한 바에 따릅니다.</li>
                    <li>"회사"는 본 "서비스"의 전부 또는 일부를 요금제, 등록정보 유무, 기타 "회사"에서 정한 조건에 따라 "회원"에게 차등적으로 제공할 수 있습니다.</li>
                </ol>

                <h3>제11조 (차량 운행정보 기록)</h3>
                <ol>
                    <li>"회원"이 등록한 차량의 운행정보기록은 다음의 내용이 "EView" 서버로 전송됩니다.
                        <ul>
                            <li>운행 중 위치정보, 운행일자, 운행시간, 운행거리, 출도착지 주소 정보, 이동경로</li>
                            <li>배터리 충전 상태(SoC), 건강 상태(SoH), 충전 이력, 에너지 소비량</li>
                            <li>OBD 단말기를 통해 수집되는 차량 진단 데이터</li>
                        </ul>
                    </li>
                    <li>"회사"는 회원의 분쟁해결, 수사기관, 국가기관, 행정청, 법원 등의 적법한 조사요구 명령 등에 대한 협조와 이행을 위한 경우 위치정보를 수집, 이용, 제공할 수 있습니다.</li>
                    <li>"회사"는 「위치정보의 보호 및 이용 등에 관한 법률」 제20조에 따라 급박한 위험으로부터 긴급구조 요청이 있는 경우에는 본인의 동의 없이도 개인위치정보가 긴급구조기관에게 제공될 수 있습니다.</li>
                </ol>

                <h3>제12조 (서비스 요금)</h3>
                <ol>
                    <li>"회사"가 제공하는 "서비스"는 요금제에 따라 이용료가 부과됩니다. 요금제는 베이직, 스탠다드, 프리미엄, 엔터프라이즈로 구분되며, 각 요금제에 따라 제공되는 기능이 다릅니다.</li>
                    <li>월간 결제와 연간 결제를 선택할 수 있으며, 연간 결제 시 할인이 적용됩니다. 이용료는 선불로 결제됩니다.</li>
                    <li>"회원"의 미납액이 발생하는 경우 "회원"에게 납부의 의무가 있으며 30일 이상 지속될 경우 서비스에 제한이 될 수 있습니다.</li>
                    <li>"회원"은 미납액에 대한 포기 및 취소는 불가능하며, 이용료 지불에 대한 납세의 책임 또한 "회원"에게 있습니다.</li>
                    <li>이용 중 요금제 변경은 차기 결제일부터 적용됩니다.</li>
                </ol>

                <h3>제13조 (이용요금의 납입)</h3>
                <ol>
                    <li>"회원"은 유료서비스를 이용하는 경우 이용대금을 납부한 후 서비스를 이용하는 것을 원칙으로 합니다.</li>
                    <li>유료서비스에 대한 이용요금의 결제 방법은 카드결제, 계좌이체, 무통장입금, 기타 전자적 지급방법 등이 있으며 각 유료서비스마다 결제 방법과 금액의 차이가 있을 수 있습니다.</li>
                    <li>매월 정기적인 결제가 이루어져야하는 서비스의 경우 "회원"이 해당 서비스의 선결제를 완료한 후 서비스의 계속적 이용이 가능합니다.</li>
                    <li>"회사"는 결제의 이행을 위하여 반드시 필요한 "회원"의 개인정보를 추가적으로 요구할 수 있으며, "회원"은 정확하게 제공하여야 합니다.</li>
                </ol>

                <h3>제14조 ("회원"의 의무)</h3>
                <ol>
                    <li>"회원"은 관계법령, 이 약관의 규정, 이용안내 및 주의사항 등 "회사"가 통지하는 사항을 준수하여야 하며, 기타 "회사"의 업무에 방해되는 행위를 하여서는 안 됩니다.</li>
                    <li>"회원"은 "회사"의 사전 승낙 없이 "서비스"를 이용하여 어떠한 영리행위도 할 수 없습니다.</li>
                    <li>"회원"은 "서비스"를 이용하여 얻은 정보를 "회사"의 사전 승낙 없이 복사, 복제, 변경, 번역, 출판·방송 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없습니다.</li>
                    <li>"회원"은 "서비스" 이용과 관련하여 다음 각 호의 행위를 하여서는 안 됩니다.
                        <ul>
                            <li>다른 "회원"의 아이디(ID)를 부정사용하는 행위</li>
                            <li>범죄행위를 목적으로 하거나 기타 범죄행위와 관련된 행위</li>
                            <li>타인의 지적재산권 등의 권리를 침해하는 행위</li>
                            <li>해킹행위 또는 컴퓨터 바이러스의 유포행위</li>
                            <li>"서비스"의 안정적인 운영에 지장을 주거나 줄 우려가 있는 일체의 행위</li>
                            <li>"회사"의 동의 없이 영리를 목적으로 "서비스"를 사용하는 행위</li>
                            <li>OBD 데이터를 무단으로 외부에 유출하거나 변조하는 행위</li>
                            <li>기타 관계법령에 위배되는 행위</li>
                        </ul>
                    </li>
                </ol>

                <h3>제15조 (휴면계정 관리)</h3>
                <ol>
                    <li>"회사"는 "회원"이 12개월 이상 로그인하지 않으면, 휴면계정으로 간주하고 서비스 이용을 제한할 수 있습니다.</li>
                    <li>휴면계정 전환 시 기간 만료 30일 전 "회원"이 등록한 전자우편을 통해 안내문을 통지합니다.</li>
                    <li>휴면계정화 이후 "회원"이 재방문 후 본인인증 절차를 거치면 기존 계정 정보를 복원하여 사용 가능합니다.</li>
                </ol>

                <h3>제16조 ("회사"의 의무)</h3>
                <ol>
                    <li>"회사"는 관련법과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 "서비스"를 제공하기 위하여 최선을 다하여 노력합니다.</li>
                    <li>"회사"는 "회원"이 안전하게 "서비스"를 이용할 수 있도록 개인정보(신용정보 포함) 보호를 위해 보안시스템을 갖추어야 하며 개인정보취급방침을 공시하고 준수합니다.</li>
                    <li>"회사"는 서비스 이용과 관련하여 "회원"으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다.</li>
                </ol>

                <h3>제17조 ("회원"에 대한 통지)</h3>
                <ol>
                    <li>"회사"가 "회원"에 대한 통지를 하는 경우 "EView"의 공지 게시 공간 또는 전자우편 및 우편의 발송을 통해 통지할 수 있습니다.</li>
                    <li>"회사"는 "회원" 일부 및 전체에 대한 통지의 경우 7일 이상 "EView"의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.</li>
                </ol>

                <h3>제18조 (서비스의 변경)</h3>
                <ol>
                    <li>"회사"는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 "서비스"를 변경할 수 있습니다.</li>
                    <li>"서비스"의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등을 변경 전 7일 이상 해당 서비스 초기화면에 게시하여야 합니다.</li>
                    <li>"회사"는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 "회원"에게 별도의 보상을 하지 않습니다.</li>
                </ol>

                <h3>제19조 (권리의 귀속)</h3>
                <ol>
                    <li>"서비스"에 대한 저작권 및 지적재산권은 "회사"에 귀속됩니다. 단, "회원"의 데이터 및 제휴계약에 따라 제공된 저작물 등은 제외합니다.</li>
                    <li>"회사"는 서비스와 관련하여 "회원"에게 "서비스"를 이용할 수 있는 이용권만을 부여하며, "회원"은 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.</li>
                    <li>"회원"은 명시적으로 허락된 내용을 제외하고는 "서비스"를 통해 얻어지는 정보를 영리 목적으로 사용, 복사, 유통할 수 없습니다.</li>
                </ol>

                <h3>제20조 (양도금지)</h3>
                <p>"회원"이 서비스의 이용권한, 기타 이용계약상 지위를 타인에게 양도, 증여할 수 없으며, 이를 담보로 제공할 수 없습니다.</p>

                <h3>제21조 (계약해지 및 이용제한)</h3>
                <ol>
                    <li>"회원"이 이용계약을 해지하고자 하는 때에는 본인이 "EView" 서비스 상의 신청 또는 전자우편을 통하여 해지하고자 하는 날의 2일 전까지 이를 "회사"에 신청하여야 합니다.</li>
                    <li>"회원"이 계약을 해지할 경우, 관련법 및 개인정보취급방침에 따라 "회사"가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 "회원"의 모든 데이터는 소멸됩니다.</li>
                    <li>"회사"는 "회원"이 이 약관의 의무를 위반하거나 "서비스"의 정상적인 운영을 방해한 경우, 경고, 일시정지, 영구이용정지, 강제탈퇴조치 또는 계약해지 등으로 "서비스" 이용을 단계적으로 제한할 수 있습니다.</li>
                    <li>본 조에 따른 영구이용정지, 강제탈퇴조치, 계약해제·해지 시에는 "서비스" 이용을 통해 획득한 혜택 등도 모두 소멸되며, "회사"는 이에 대해 별도로 보상하지 않습니다.</li>
                </ol>

                <h3>제22조 (책임제한)</h3>
                <ol>
                    <li>"회사"는 천재지변 또는 이에 준하는 불가항력으로 인하여 "서비스"를 제공할 수 없는 경우에는 "서비스" 제공에 관한 책임이 면제됩니다.</li>
                    <li>"회사"는 "회원"의 귀책사유로 인한 "서비스" 이용의 장애에 대하여는 책임을 지지 않습니다.</li>
                    <li>OBD 단말기의 설치, 탈착, 고장에 따른 데이터 수집 불능에 대해서는 단말기 제조사의 보증 정책이 적용됩니다.</li>
                    <li>"회원" 아이디(ID)와 "비밀번호"의 관리 및 이용 상의 부주의로 인하여 발생되는 손해 또는 제3자에 의한 부정사용 등에 대한 책임은 모두 "회원"에게 있습니다.</li>
                    <li>"회사"가 "회원"에게 손실 및 손해에 대해 지불하는 피해보상금액은 서비스 금액을 넘지 않습니다.</li>
                </ol>

                <h3>제23조 (결제 취소 및 환불)</h3>
                <ol>
                    <li>"유료서비스" 결제 후 고객이 서비스를 이용한 기간에 해당하는 금액은 환불이 불가능합니다.</li>
                    <li>환불 요청 시, 환불 금액은 다음 기준에 따라 산정됩니다.
                        <ul>
                            <li>남은 일수에 해당하는 금액을 일할 계산하여 환불합니다.</li>
                            <li>이미 사용한 기간에 대해서는 월간 요금 기준으로 재산정하며, 연간 결제 시 적용된 할인 금액은 환불 금액에서 차감됩니다.</li>
                            <li>위 기준에 따라 산정된 환불 금액에서 환불 수수료(10% 또는 1,000원 중 큰 금액)를 추가로 차감하여 최종 환불 금액이 정해집니다.</li>
                        </ul>
                    </li>
                    <li>"회사"의 책임 있는 사유로 과오금이 발생한 경우 "회사"는 과오금 전액을 환불합니다.</li>
                    <li>환불을 원하는 고객은 고객센터를 통해 환불 요청을 하여야 하며, "회사"는 환불 요청을 받은 후 5영업일 이내에 환불 가능 여부 및 환불 금액을 고객에게 통보합니다.</li>
                    <li>환불이 승인된 경우, 승인일로부터 7영업일 이내에 원래의 결제 수단으로 환불됩니다.</li>
                    <li>이미 사용 기간이 종료된 "유료서비스"에 대해서는 환불이 불가능합니다.</li>
                </ol>

                <h3>제24조 (분쟁의 해결 및 준거법)</h3>
                <ol>
                    <li>"회사"와 "회원"은 "서비스"와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을 하여야 합니다.</li>
                    <li>"회사"와 "회원" 간 발생한 분쟁으로 인하여 소송이 제기될 경우 동 소송은 대한민국법을 준거법으로 하며, "회사"의 본사소재지를 관할하는 법원의 관할로 합니다.</li>
                </ol>

                <h3>부칙</h3>
                <p>이 약관은 2026년 3월 12일부터 적용됩니다.</p>

                <div className="terms-footer-info">
                    <p>㈜프리딕션 (Prediction Inc.)</p>
                    <p>EView - EV Fleet 통합관리 솔루션</p>
                </div>
            </>
        )
    },
    location: {
        title: '위치정보 이용약관',
        content: (
            <>
                <p>이 약관은 (주)프리딕션(이하 "프리딕션")이 제공하는 프리딕션 관련 제반 서비스의 이용과 관련하여 "프리딕션"과 이용자의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>

                <h3>제 1 조 목적</h3>
                <p>1. 본 약관은 회원(차량운행일지 위치기반 서비스 약관에 동의한 자)을 말합니다.(이하 “회원”이라고 함)이 (주)프리딕션(이하 “프리딕션”이라 함)이 제공하는 차량운행일지 위치기반 서비스(이하 “서비스”라고 합니다)를 이용함에 있어 회사와 회원의 권치 및 의무, 기타 제반 사항을 정함을 목적으로 합니다.</p>

                <h3>제2조 가입자격</h3>
                <p>1. 서비스에 가입할 수 있는 회원은 위치기반서비스를 이용할 수 있는 이동전화 단말기, 기타 서비스를 이용할 수 있는 단말기(이하 “단말기”)의 소유자 본인이어야 합니다.</p>

                <h3>제3조 서비스 가입</h3>
                <ol>
                    <li>실명이 아니거나 다른 사람의 명의를 사용하는 등 허위로 신청하는 경우</li>
                    <li>고객 등록 사항을 누락하거나 오기하여 신청하는 경우</li>
                    <li>공공질서 또는 미풍양속을 저해하거나 저해할 목적을 가지고 신청하는 경우</li>
                    <li>기타 회사가 정한 이용신청 요건이 충족되지 않았을 경우</li>
                </ol>

                <h3>제4조 서비스 해지</h3>
                <p>1. 서비스 해지를 희망하는 회원은 회사가 정한 절차를 통해 서비스 해지를 신청할 수 있습니다.</p>

                <h3>제5조 이용약관의 효력 및 변경</h3>
                <ol>
                    <li>회원이 본 약관에 동의하고 회사가 정한 소정의 절차에 따라 회원이 서비스의 이용자로 등록됨으로써 본 약관의 효력이 발생합니다.</li>
                    <li>회원이 앱에서 본 약관의 "동의하기" 버튼을 클릭하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 그 적용에 동의한 것으로 봅니다</li>
                    <li>회사는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법, 약관의 규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</li>
                    <li>회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 회사 홈페이지에 최소 30 일 전부터 적용일자 전까지 공지하여야 합니다.</li>
                </ol>

                <h3>제6조 관계법령의 적용</h3>
                <p>1. 본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령 또는 상관례에 따릅니다.</p>

                <h3>제7조 서비스의 내용</h3>
                <table className="terms-table">
                    <thead>
                        <tr>
                            <th>구분</th>
                            <th>내용</th>
                            <th>비고</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>EView</td>
                            <td>
                                1. 업무용 차량 운행정보관리 및 모니터링<br />
                                2. 업무용 차량 운행일지 기록 및 보관 관리<br />
                                3. 차량 출발지, 도착지, 운행 중 지점 위치
                            </td>
                            <td>유무료 서비스</td>
                        </tr>
                    </tbody>
                </table>

                <h3>제8조 서비스 이용요금</h3>
                <ol>
                    <li>회사가 제공하는 서비스는 기본적으로 무료입니다. 단, 별도의 유료 서비스의 경우 해당 서비스에 명시된 요금을 지불하여야 사용 가능합니다.</li>
                    <li>회사는 유료 서비스 이용요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수 있습니다.</li>
                    <li>유료서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제 이용약관 등 관계법에 따릅니다.</li>
                </ol>

                <h3>제 11 조 개인위치정보의 이용 또는 제공</h3>
                <ol>
                    <li>회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.</li>
                    <li>회사는 개인위치정보주체의 동의 없이 개인위치정보를 제 3 자에게 제공하지 아니합니다.</li>
                    <li>회사는 타사업자 또는 이용 고객과의 요금정산 및 민원처리를 위해 위치정보 이용·제공 사실 확인 자료를 자동 기록·보존하며, 해당 자료는 1 년간 보관합니다.</li>
                    <li>운전자 회원의 개인위치정보는 업무용 차량관제 또는 운행일지 서비스를 위해서 소속 법인회원에게 제공됩니다.</li>
                </ol>

                <h3>제12조 개인위치정보의 수집∙이용∙제공 및 보유기간</h3>
                <table className="terms-table">
                    <thead>
                        <tr>
                            <th>서비스명</th>
                            <th>수집∙이용∙제공 목적</th>
                            <th>보유기간</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>EView</td>
                            <td>
                                1. 업무용 차량 운행정보관리 및 모니터링 목적<br />
                                2. 업무용 차량 운행일지 기록 및 보관 관리 목적<br />
                                3. 차량 출발지, 도착지, 운행 중 지점 위치 안내 목적
                            </td>
                            <td>회원탈퇴(서비스 해지) 또는 개인위치정보 유효기간 도래시까지 보관</td>
                        </tr>
                    </tbody>
                </table>

                <h3>제16조 위치정보관리책임자의 지정</h3>
                <p>1. 소 속 : 프리딕션 사업부 김두호<br />2. 연 락 처 : 070-7797-7437</p>

                <h3>제20조 회사의 연락처</h3>
                <ol>
                    <li>상 호 : (주)프리딕션</li>
                    <li>대 표 자 : 김두호</li>
                    <li>주 소 : 경기도 과천시 나길 과천대로 7 37 디 엠(The M), 403호 갈현동 423-2</li>
                    <li>대표전화 : 070-7797-7437</li>
                </ol>

                <div className="terms-footer-info">
                    <p>부칙</p>
                    <p>제 1조(시행일) 이 약관은 2023년 1월 1일부터 적용됩니다.</p>
                </div>
            </>
        )
    },
    privacy: {
        title: '개인정보 수집 및 이용',
        content: (
            <>
                <p>(주)프리딕션 (이하 “프리딕션”이라 함)은 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법, 통신비밀보호법, 전기통신사업법 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.</p>
                <p>프리딕션은 개인정보 수집 및 이용약관을 통해 이용자들이 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다. 회사의 개인정보 수집 및 이용약관은 법률 및 지침 변경이나 회사의 내부 방침 변경 등으로 인하여 수시로 변경될 수 있으며, 개인정보 수집 및 이용약관의 지속적인 개선을 위하여 필요한 절차를 정하고 있습니다. 프리딕션은 스마트폰 또는 OBD 단말기를 기반으로 차량의 이동 거리 측정과 운행일지 작성에 필요한 기능을 제공하기 위해 사용자의 위치정보 및 운행 데이터를 수집하고 있습니다.</p>
                <p>프리딕션은 고객의 사생활을 현저하게 침해할 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않습니다. 다만, 서비스 제공을 위해 일부 민감정보를 필요최소한으로 수집, 처리할 필요가 있는 경우 관련 법령의 제한에 따라 고객의 동의 등 필요한 조치를 거쳐 개인정보를 수집, 처리할 수 있습니다.</p>

                <h3>제 1조 수집하는 개인정보의 항목 및 수집방법</h3>
                <ol>
                    <li>"프리딕션"은 회원가입, 원활한 고객상담, 각종 서비스 제공을 위해 아래와 같은 항목의 개인정보를 수집하고 있습니다.
                        <ul>
                            <li><strong>EView 어플리케이션 사용자:</strong> 스마트폰 위치 정보, 아이디, 회사명, 부서명, 차량번호, 차량보험가입 정보</li>
                            <li><strong>웹 통합 관리자:</strong> 아이디, 회사명, 성명, 연락처, 사업자등록번호, 이메일, 회사주소</li>
                        </ul>
                    </li>
                    <li>서비스 이용과정에서 아래와 같은 정보들이 생성되어 수집될 수 있습니다.
                        <ul>
                            <li>아이피, 방문 일시, 서비스 이용 기록, 불량 이용 기록</li>
                        </ul>
                    </li>
                    <li>유료 서비스 이용 과정에서 아래와 같은 결제 정보들이 수집 됩니다.
                        <ul>
                            <li>신용카드 결제시: 카드사명, 카드정보</li>
                            <li>휴대전화 결제시: 이동전화번호, 통신사, 결제승인번호 등</li>
                            <li>계좌이체 시: 은행명</li>
                        </ul>
                    </li>
                </ol>

                <h3>제 2조 개인정보의 수집 및 이용 목적</h3>
                <ol>
                    <li><strong>서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산:</strong> 콘텐츠 제공, 특정 맞춤 서비스 제공, 본인인증, 구매 및 요금 결제</li>
                    <li><strong>회원관리:</strong> 회원제 서비스 이용에 따른 본인여부 확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 연령확인, 가입의사확인, 가입 및 가입횟수 제한, 법적대리인 본인확인, 분쟁 조정을 위한 기록보존, 민원처리, 고지사항 전달</li>
                    <li><strong>신규 서비스 개발 및 마케팅 · 광고에의 활용:</strong> 신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 참여기회 제공 또는 광고성 정보 제공, 접속빈도 파악, 회원의 서비스이용에 대한 통계</li>
                </ol>

                <h3>제 3 조 개인정보의 이용목적/항목 및 보유기간</h3>
                <table className="terms-table">
                    <thead>
                        <tr>
                            <th>목적</th>
                            <th>항목</th>
                            <th>보유기간</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>이용자 확인 및 서비스 제공</td>
                            <td>이름, 기업명, 아이디, 이메일주소, 차량 번호, 단말기 정보 등</td>
                            <td>회원탈퇴 또는 유효기간 도래시까지</td>
                        </tr>
                        <tr>
                            <td>운행일지 작성, 경로 제공</td>
                            <td>위치정보 및 조회기록</td>
                            <td>동일</td>
                        </tr>
                        <tr>
                            <td>고객 상담 및 부정 이용 방지</td>
                            <td>이름, 기업명, 아이디, 단말기 정보, 서비스 이용 기록</td>
                            <td>동일</td>
                        </tr>
                        <tr>
                            <td>유료 서비스 결제 및 정산</td>
                            <td>결제 정보, 신용카드 정보, 계좌정보, 연락처 등</td>
                            <td>동일</td>
                        </tr>
                    </tbody>
                </table>
                <p>* 개인정보 유효기간: 고객문의 및 불만 대응을 위해 탈퇴 후 1년간 보관</p>
                <p>* 개인위치정보: 회원탈퇴 시 즉시 파기 (단, 관계법령에 따른 보존 필요 시 해당 기간 보관)</p>

                <h3>제 4 조 개인정보의 제 3 자 제공</h3>
                <p>"프리딕션"은 개인정보의 처리 목적에서 고지한 범위 내에서 개인정보를 3자에게 제공하며, 범위를 초과하여 제공하지 않습니다. 다만, 이용자가 사전에 동의한 경우나 다른 법률에 특별한 규정이 있는 경우 등은 예외로 합니다.</p>

                <h3>제 5 조 개인위치정보의 수집∙이용∙제공 및 보유기간</h3>
                <ol>
                    <li>회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.</li>
                    <li><strong>서비스명 (EView):</strong> 업무용 차량 운행정보관리, 운행일지 기록 및 보관, 차량 위치 안내 목적으로 수집하며 회원탈퇴 시까지 보관합니다.</li>
                </ol>

                <h3>제 8 조 개인정보처리의 위탁</h3>
                <p>"프리딕션"은 서비스 제공을 위해 아래와 같은 기관에 개인정보 처리를 위탁하고 있습니다.</p>
                <ul>
                    <li><strong>나이스페이먼츠, 엘지유플러스:</strong> 전자 결제 서비스 (데이터 수신 5년 후 파기)</li>
                    <li><strong>나이스정보통신:</strong> 휴대폰 본인 인증</li>
                </ul>

                <h3>제 10 조 개인정보 및 개인위치정보 파기</h3>
                <p>회사는 처리목적이 달성되거나 보유기간이 경과하면 복구 및 재생이 불가능한 방법으로 지체없이 파기합니다. 전자적 파일은 기술적 방법으로 삭제하며, 종이 문서는 분쇄하거나 소각합니다.</p>

                <h3>제 13 조 기술적/관리적 보호 대책</h3>
                <p>회사는 개인정보 보호를 위해 암호화(SSL), 접근 권한 관리, 침입차단시스템 운영 등 최선의 대책을 강구하고 있습니다.</p>
                <p><strong>위치정보관리책임자:</strong> 프리딕션 사업부 김두호 (070-7797-7437)</p>

                <div className="terms-footer-info">
                    <p>부칙</p>
                    <p>제 1조(시행일) 이 약관은 2026년 3월 12일부터 적용됩니다.</p>
                    <p>(주)프리딕션 (Prediction Inc.)</p>
                </div>
            </>
        )
    }
};

export default function TermsOverlay({ type, onClose }: TermsOverlayProps) {
    const { title, content } = termsContent[type];

    return (
        <div className="terms-overlay" onClick={onClose}>
            <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
                <div className="terms-modal-header">
                    <h2>{title}</h2>
                    <button className="terms-close-btn" onClick={onClose}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>
                <div className="terms-modal-body">
                    {content}
                </div>
                <div className="terms-modal-footer">
                    <button className="terms-confirm-btn" onClick={onClose}>확인</button>
                </div>
            </div>
        </div>
    );
}
